function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeSalesAnalytics = function SvgEyeSalesAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 21554",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.792 27.792"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21551"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17743",
    d: "M15.786 12.393A3.393 3.393 0 1 1 12.393 9a3.393 3.393 0 0 1 3.393 3.393z",
    transform: "translate(1.218 1.736)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "currentColor",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17744",
    d: "M2.458 12.917a11.314 11.314 0 0 1 21.584 0 11.314 11.314 0 0 1-21.584 0z",
    transform: "translate(.361 .835)",
    style: {
      strokeWidth: 2,
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26063",
    d: "M12.242 10.621A1.621 1.621 0 1 1 10.621 9a1.621 1.621 0 0 1 1.621 1.621z",
    transform: "translate(3.793 2.48)",
    style: {
      fill: "#f4f4f7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 19851",
    style: {
      fill: "none"
    },
    d: "M0 0h27.792v27.792H0z"
  }));
};

export default SvgEyeSalesAnalytics;